import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative min-h-screen w-full bg-gradient-to-br from-navy via-navy-light to-navy flex items-center overflow-hidden" data-id="element-109">
      {/* Geometric background pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-110">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" data-id="element-111">
          <defs data-id="element-112">
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-113">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="1" className="text-teal" data-id="element-114" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" data-id="element-115" />
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-116">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-117">
          {/* Left column - Text content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-118">
            <motion.h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-6 leading-tight" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2,
            duration: 0.8
          }} data-id="element-119">
              Si estudias con el celular cerca,{' '}
              <span className="text-teal" data-id="element-120">ya perdiste.</span>
            </motion.h1>

            <motion.p className="text-xl sm:text-2xl text-gray-300 mb-8 leading-relaxed" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4,
            duration: 0.8
          }} data-id="element-121">
              El método{' '}
              <span className="font-bold text-teal" data-id="element-122">
                "Fricción + Reemplazo"
              </span>{' '}
              para cortar el scroll automático y recuperar tu estudio — sin
              fuerza de voluntad.
            </motion.p>

            <motion.p className="text-lg text-gray-400 mb-10" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.6,
            duration: 0.8
          }} data-id="element-123">
              Un PDF práctico para estudiantes (en español) que están hartos de
              perder horas en TikTok/IG/Shorts justo cuando más necesitan
              enfocarse.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.8,
            duration: 0.8
          }} data-id="element-124">
              <CTAButton size="large" href="https://tusistemasimple.com/cart/47523415556148:1" data-id="element-125">
                Descarga RESET de Scroll (7 días)
              </CTAButton>
              <p className="text-sm text-gray-400 mt-4" data-id="element-126">
                Solo $10 — Acceso inmediato
              </p>
            </motion.div>
          </motion.div>

          {/* Right column - Hero image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.4,
          duration: 1
        }} className="relative" data-id="element-127">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-128">
              <img src="https://cdn.magicpatterns.com/uploads/5Sz3Zdoc1geDypjDubJCZf/heylloyd-image-1771673324989.png" alt="RESET de Scroll - Método Fricción + Reemplazo para estudiar sin el celular" className="w-full h-auto" data-id="element-129" />
              {/* Teal glow effect */}
              <div className="absolute inset-0 bg-gradient-to-tr from-teal/20 to-transparent pointer-events-none" data-id="element-130"></div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Bottom wave divider */}
      <div className="absolute bottom-0 left-0 right-0" data-id="element-131">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" data-id="element-132">
          <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="white" data-id="element-133" />
        </svg>
      </div>
    </section>;
}